export default __webpack_public_path__ + "static/media/Image5.655c9337.jpg";